export const setPhaseStatus = (
  status: string,
) => {
  const stats = status.toLowerCase();
  return stats.replace(' ', '-');
};

export const capitalizeFirstChar = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export const createKeywords = (name: string): string[] => {
  const arrayName: string[] = [];
  let currentName = '';

  name.split('').forEach((letter) => {
    currentName += letter;
    arrayName.push(currentName);
  });

  return arrayName;
};

export const generateNameKeywords = (names: {
  firstName: string;
  middleName?: string;
  lastName: string;
}): string[] => {
  const { firstName, middleName, lastName } = names;
  const [firstNameLower, middleNameLower, lastNameLower] = [
    firstName.toLocaleLowerCase(),
    middleName?.toLocaleLowerCase(),
    lastName.toLocaleLowerCase(),
  ];

  const middleNameOnly = createKeywords(`${middleNameLower}`);

  const keywordNameWithoutMiddle = createKeywords(
    `${firstNameLower} ${lastNameLower}`,
  );
  const keywordLastNameWithoutMiddle = createKeywords(
    `${lastNameLower} ${firstNameLower}`,
  );
  const keywordLastNameFirst = createKeywords(
    `${lastNameLower} ${firstNameLower} ${middleNameLower}`,
  );
  const keywordFullName = createKeywords(
    `${firstNameLower} ${middleNameLower} ${lastNameLower}`,
  );
  const middleInitial =
  middleNameLower && middleNameLower.length > 0 ? `${middleNameLower[0]}.` : '';

  const keywordFullNameMiddleInitial = createKeywords(
    `${firstNameLower} ${middleInitial} ${lastNameLower}`,
  );
  const keywordLastNameFirstMiddleInitial = createKeywords(
    `${lastNameLower} ${firstNameLower} ${middleInitial}`,
  );

  const uniqueNameKeywords = new Set([
    ...keywordNameWithoutMiddle,
    ...keywordLastNameWithoutMiddle,
    ...keywordLastNameFirst,
    ...keywordFullName,
    ...keywordFullNameMiddleInitial,
    ...keywordLastNameFirstMiddleInitial,
    ...middleNameOnly,
  ]);

  return [...uniqueNameKeywords];
};

export const camelize = (str: string) => {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
}

export const generateStartSuffixForEllipsis = (phrase: string, suffixCount = 12): { start: string, suffix: string } => {
  const start = phrase.slice(0, phrase.length - suffixCount).trim();
  const suffix = phrase.slice(-suffixCount).trim();

  return { start, suffix };
};

